import { render, staticRenderFns } from "./SelectBusinessType.vue?vue&type=template&id=374cd5a0&"
import script from "./SelectBusinessType.vue?vue&type=script&lang=js&"
export * from "./SelectBusinessType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports